import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, RefreshCw, Leaf, Droplet, Gift, Heart, ArrowRight, Play } from 'lucide-react';
import DiagnosticModal from '../components/DiagnosticModal';

const PRODUCTS = [
  {
    slug: 'rituels',
    icon: <Sparkles size={26} />,
    title: 'Rituels Parfum',
    subtitle: 'Flacon + consultation 15 min offerte',
    description: 'Réservez votre format et budget en ligne, nos experts révèlent votre signature olfactive en boutique ou en visio.',
    price: 'dès 15€',
    color: '#5C2018',
    image: '/assets/bar-parfum-flacons.jpg',
  },
  {
    slug: 'abonnement',
    icon: <RefreshCw size={26} />,
    title: 'Abonnement',
    subtitle: 'Mon flacon nomade, chaque mois',
    description: 'Recevez chaque mois votre flacon 10 ml rechargé avec votre parfum signature, sans engagement.',
    price: 'dès 10€/mois',
    color: '#1E7A6A',
    image: '/assets/gallery/flacon_nomade.jpg',
  },
  {
    slug: 'recharges',
    icon: <Leaf size={26} />,
    title: 'Recharges',
    subtitle: 'Geste éco-responsable',
    description: 'Rechargez votre flacon existant à prix réduit — jusqu\'à -15% par rapport au flacon neuf.',
    price: 'dès 9€',
    color: '#2E120D',
    image: '/assets/ai-recharge-transparent.jpg',
  },
  {
    slug: 'echantillons',
    icon: <Droplet size={26} />,
    title: 'Échantillons 2 ml',
    subtitle: 'Sentir avant d\'aimer',
    description: 'Testez une fragrance quelques jours avant de vous engager — déductible de votre Rituel ensuite.',
    price: '2€',
    color: '#B8922A',
    image: '/assets/ai-echantillon-2ml.jpg',
  },
  {
    slug: 'bons-cadeaux',
    icon: <Gift size={26} />,
    title: 'Bons cadeaux',
    subtitle: 'Offrir un moment Harmony',
    description: 'Une carte cadeau de 10 à 500€ pour offrir consultation + parfum à la personne de votre choix.',
    price: 'dès 10€',
    color: '#5C2018',
    image: '/assets/coffrets.jpg',
  },
  {
    slug: 'vaporisateur',
    icon: <Sparkles size={26} />,
    title: 'Vaporisateur de sac',
    subtitle: 'L\'accessoire nomade · 5 coloris',
    description: 'Mini-flacon métallique rechargeable 5 ou 12 ml pour emporter votre parfum partout.',
    price: 'dès 5€',
    color: '#1E7A6A',
    image: '/assets/vapo-5ml-hayat.jpg',
  },
  {
    slug: 'fragrances',
    icon: <Heart size={26} />,
    title: 'Nos Fragrances',
    subtitle: 'Le bar à parfum, dès 10€',
    description: 'Explorez nos 3 gammes — Iconiques, Pépites et Audacieux — pour trouver votre signature.',
    price: 'dès 10€',
    color: '#2E120D',
    image: '/assets/bar-parfum-vitrine-blurred.jpg',
  },
  {
    slug: 'coffret',
    icon: <Gift size={26} />,
    title: 'Coffret cadeau',
    subtitle: 'L\'écrin sur-mesure · supplément',
    description: 'Écrin bordeaux/doré + ruban satiné + étiquette manuscrite à offrir avec votre Rituel.',
    price: '5€',
    color: '#B8922A',
    image: '/assets/coffrets.jpg',
  },
];

const BoutiqueHubPage = () => {
  const [diagOpen, setDiagOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#FDFAF4] pb-20">
      <DiagnosticModal open={diagOpen} onClose={() => setDiagOpen(false)} />
      {/* HERO */}
      <section className="relative py-16 px-6 bg-[#FDFAF4] border-b border-[#B8922A]/20 overflow-hidden" data-testid="hub-hero">
        <img
          src="/assets/rose-filigrane.jpg"
          alt=""
          aria-hidden="true"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] object-contain pointer-events-none select-none mix-blend-multiply opacity-[0.07]"
        />
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-3">La boutique Harmony</p>
          <h1
            className="text-5xl md:text-6xl font-light mb-5 text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            data-testid="hub-title"
          >
            Tout notre univers, en ligne
          </h1>
          <p className="text-base text-[#332724] font-light leading-relaxed max-w-2xl mx-auto mb-6">
            Click & Collect en boutique ou livraison France (8,90€, offerte dès 60€ d'achat).
            <br />
            <span className="text-sm italic">Une consultation 15 min offerte, à utiliser comme vous voulez.</span>
          </p>
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#B8922A]/80 mb-6 italic">
            📸 Photos non contractuelles · présentations susceptibles de varier
          </p>
          <button
            onClick={() => setDiagOpen(true)}
            className="inline-flex items-center gap-3 bg-[#B8922A] hover:bg-[#9a7922] text-[#FDFAF4] px-7 py-3 rounded-full text-xs uppercase tracking-[0.2em] transition-colors shadow-[0_10px_30px_rgba(184,146,42,0.3)]"
            data-testid="diagnostic-open-btn"
          >
            <Sparkles size={16} />
            Trouvez votre parfum en 30 secondes
          </button>
        </div>
      </section>

      {/* GRILLE PRODUITS (7 cartes) */}
      <section className="py-12 px-6" data-testid="hub-grid">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {PRODUCTS.map((p) => (
              <Link
                key={p.slug}
                to={`/boutique/${p.slug}`}
                className="group bg-white rounded-2xl border border-gold overflow-hidden hover:shadow-[0_15px_50px_rgba(92, 32, 24,0.15)] transition-all"
                data-testid={`product-card-${p.slug}`}
              >
                <div className="relative h-48 overflow-hidden bg-[#FDFAF4]">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 right-3 w-11 h-11 rounded-full bg-[#FDFAF4]/95 backdrop-blur-sm flex items-center justify-center" style={{ color: p.color }}>
                    {p.icon}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl mb-1" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', color: p.color }}>
                    {p.title}
                  </h3>
                  <p className="text-sm text-[#332724]/80 font-light mb-2">{p.subtitle}</p>
                  <p className="text-xs text-[#332724]/65 font-light leading-relaxed mb-4 italic">
                    {p.description}
                  </p>
                  <div className="flex items-center justify-between pt-3 border-t border-[#B8922A]/15">
                    <span className="text-xs uppercase tracking-[0.2em] font-medium" style={{ color: p.color }}>
                      {p.price}
                    </span>
                    <span className="text-xs uppercase tracking-[0.2em] text-[#B8922A] group-hover:gap-3 flex items-center gap-2 transition-all">
                      Découvrir <ArrowRight size={14} />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* VIDÉO VISITE VIRTUELLE */}
      <section className="py-16 px-6 bg-white border-t border-[#B8922A]/10" data-testid="hub-video">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-8">
            <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-3 flex items-center justify-center gap-2">
              <Play size={14} /> Visite virtuelle
            </p>
            <h2
              className="text-3xl md:text-4xl font-light mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              Bienvenue chez Harmony
            </h2>
            <p className="text-sm text-[#332724] font-light leading-relaxed max-w-2xl mx-auto">
              Découvrez en images notre bar à parfums concept store, au cœur du Polygone de Béziers.
            </p>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(92, 32, 24,0.15)] aspect-video bg-[#332724]">
            <video
              src="/assets/boutique-visite-virtuelle.mp4"
              poster="/assets/boutique_3.jpg"
              controls
              playsInline
              className="w-full h-full object-cover"
              data-testid="visite-video"
            >
              Votre navigateur ne supporte pas la vidéo.
            </video>
          </div>
          <p className="text-center text-xs text-[#332724]/60 italic mt-5">
            Envie de venir nous voir ?{' '}
            <Link to="/rendez-vous" className="text-[#B8922A] hover:underline">Prenez rendez-vous</Link>.
          </p>
        </div>
      </section>

      {/* Coaching teaser */}
      <section id="coaching" className="py-14 px-6 bg-[#FDFAF4] border-t border-[#B8922A]/10 scroll-mt-20" data-testid="hub-coaching">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-[#1E7A6A] mb-3">🌸 Accompagnement</p>
          <h2 className="text-3xl text-[#5C2018] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
            Le coaching Harmony
          </h2>
          <p className="text-sm text-[#332724] font-light mb-5">
            Au-delà du parfum, Hayat vous accompagne en gestion du stress, des émotions et communication non violente.
          </p>
          <Link to="/coaching" className="inline-block btn-primary px-7 py-2.5 rounded-full text-xs uppercase tracking-[0.2em]" data-testid="goto-coaching">
            Découvrir le coaching
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BoutiqueHubPage;
